export default __webpack_public_path__ + "static/media/reviewIcon.28098fff.svg";